import { externalPath } from 'src/Config';
import { i18, trb } from 'src/Utilities';

import { IconRedirect } from '../../../Assets/svg';
import { Link } from 'src/shared/Link';

export const CookiesSettings = () => {
  const language = localStorage.getItem('language');

  const label = trb(i18.Labels.CookiesSettings, { yyyy: new Date().getFullYear() });

  return (
    <Link
      className="d-flex align-items-center lh-1 login_footer_text"
      to={externalPath[language === 'en-GB' ? 'smeBankPrivacyPolicyEn' : 'smeBankPrivacyPolicy']}
      id="cookiesSettingsButton"
      target="_blank"
      aria-label={label}
    >
      {label}
      <span
        className="ml-1"
        aria-hidden="true"
      >
        <IconRedirect size={20} />
      </span>
    </Link>
  );
};
